/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripSummaryStop: "trip-summary-stop",
  tripSummaryStartPoint: "trip-summary-start-point",
  tripSummaryEndPoint: "trip-summary-end-point",
  tripSummaryStartPointDetails: "trip-summary-start-point-details",
  tripSummaryEndPointDetails: "trip-summary-end-point-details",
  tripStopDetails: "trip-stop-details",
  tripSummarySegmentMileage: "trip-summary-segment-mileage",
  tripSummaryOpenTrip: "trip-summary-open-trip",
  tripSummaryCollapse: "trip-summary-collapse",
  tripSummaryStartTrip: "trip-summary-start-trip",
  tripSummaryLogCheckCall: "trip-summary-log-check-call",
  tripSummaryCompleteTrip: "trip-summary-complete-trip",
  tripSummaryEvent: "trip-summary-event",
  tripSummaryNotes: "trip-summary-notes",
  tripSummaryCancel: "trip-summary-cancel",
  tripSummarySave: "trip-summary-save",

  tripSummaryOpenDetails: "trip-summary-open-details",
} as const;
